import { ApiError } from '../../api/client.js';

export function signInErrorMessage(error: unknown) {
  if (error instanceof ApiError && error.status === 401 && error.code === 'invalid_credentials') {
    return 'Email or password is incorrect.';
  }
  return 'The sign-in service is unavailable. Try again.';
}
